import { I18N_COMMON_KEYS } from '../i18nCommonKeys';

export const jaTranslation: Record<string, string> = {
  [I18N_COMMON_KEYS.OK]: 'OK',
  [I18N_COMMON_KEYS.CANCEL]: 'キャンセル',
  [I18N_COMMON_KEYS.SAVE]: '保存',
  [I18N_COMMON_KEYS.CLEAR]: 'クリア',
  [I18N_COMMON_KEYS.EXECUTE]: '実行する',
  [I18N_COMMON_KEYS.CLOSE]: '閉じる',
  [I18N_COMMON_KEYS.LOADING]: '読み込み中...',
  [I18N_COMMON_KEYS.CONFIRM]: '確認',
  [I18N_COMMON_KEYS.DELETE]: '削除',
  [I18N_COMMON_KEYS.EDIT]: '編集',
  [I18N_COMMON_KEYS.CREATE]: '新規作成',
  [I18N_COMMON_KEYS.BACK]: '戻る',
  [I18N_COMMON_KEYS.NEXT]: '次へ',
  [I18N_COMMON_KEYS.PREVIOUS]: '前へ',
  [I18N_COMMON_KEYS.SEARCH]: '検索',
  [I18N_COMMON_KEYS.RESET]: 'リセット',
  [I18N_COMMON_KEYS.UPLOAD]: 'アップロード',
  [I18N_COMMON_KEYS.DOWNLOAD]: 'ダウンロード',

  [I18N_COMMON_KEYS.SUCCESS]: '成功',
  [I18N_COMMON_KEYS.ERROR]: 'エラー',
  [I18N_COMMON_KEYS.WARNING]: '警告',
  [I18N_COMMON_KEYS.INFO]: '情報',
  [I18N_COMMON_KEYS.CONFIRMATION_TITLE]: '確認',
  [I18N_COMMON_KEYS.EXECUTION_WARNING]: '実行内容には注意してください。',
  [I18N_COMMON_KEYS.NOT_FOUND]: '見つかりません',

  [I18N_COMMON_KEYS.DIALOG_OK]: 'OK',
  [I18N_COMMON_KEYS.DIALOG_CANCEL]: 'キャンセル',
  [I18N_COMMON_KEYS.DIALOG_CLOSE]: '閉じる',
  [I18N_COMMON_KEYS.TOAST_GENERAL_ERROR]: 'エラーが発生しました。',
  [I18N_COMMON_KEYS.TOAST_UPDATE_SUCCESS]: '更新しました。',
};
